import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { ProjectService } from '../services/project.service';

export const projectbotsResolver: ResolveFn<void> = async (route) => {
  const projectId = route.params["projectid"] as string;
  const projectService = inject(ProjectService);
  projectService.searchString = '';
  projectService.searchOrgShort = undefined;
  projectService.selectedProject = await projectService.getProject(projectId);
  await projectService.loadBots();
};